// extracted by mini-css-extract-plugin
export default {"shapes":"Shapes_shapes__zgoOk","shapesContainer":"Shapes_shapesContainer__xoger"};